import React, { useState } from "react";
import "./style.scss";
import EAButton from "../shared/Buttons/EAButton";
import useCardPurchaseLookup from "./useCardPurchaseLookup";
import { Ticket } from "../../models/Ticket";

const MAX_ATTEMPTS = 5;
const TIME_WINDOW = 5 * 60 * 1000; // 5 minut w ms
const COOLDOWN_MS = 5000; // 5 sekund

const CardPurchaseLookup: React.FC = () => {
  const [cardNumber, setCardNumber] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);

  const { getDetailsByCardID, cardDetails } = useCardPurchaseLookup();

  // nowo dodane:
  const [cooldown, setCooldown] = useState(false);
  const [attempts, setAttempts] = useState<number[]>([]);
  const [localError, setLocalError] = useState("");
  const [wasChecked, setWasChecked] = useState(false);
  const handleCheck = () => {
    // jeśli już cooldown trwa → nic nie rób
    if (cooldown) {
      return;
    }

    const now = Date.now();
    const windowStart = now - TIME_WINDOW;

    // odfiltrowujemy próby starsze niż 5 min
    const recentAttempts = attempts.filter((t) => t >= windowStart);

    // za dużo prób -> blokujemy i nie strzelamy requestu
    if (recentAttempts.length >= MAX_ATTEMPTS) {
      setLocalError("Zbyt wiele prób. Spróbuj ponownie za kilka minut.");
      return;
    }

    // jeśli wszystko ok -> czyścimy lokalny error
    setLocalError("");
    setWasChecked(true)
    // odpalamy normalne zapytanie
    getDetailsByCardID("273", cardNumber);

    // zapisujemy tę próbę
    setAttempts([...recentAttempts, now]);

    // włączamy cooldown
    setCooldown(true);
    setTimeout(() => {
      setCooldown(false);
    }, COOLDOWN_MS);
  };

  // przycisk ma być nieaktywny kiedy:
  // - brak numeru
  // - brak checkboxa
  // - cooldown
  // - przekroczony rate limit
  const isButtonDisabled =
    !cardNumber.trim() ||
    !isConfirmed ||
    cooldown ||
    (attempts.filter((t) => t >= Date.now() - TIME_WINDOW).length >= MAX_ATTEMPTS);

  return (
    <div className="card-purchase-lookup">
      <div className="card-purchase-lookup__title">
        <h4>Sprawdź status swojej karty</h4>
        <p>
          Wprowadź numer swojej karty <strong>(bez kropek)</strong>, aby
          wyświetlić przypisane do niej saldo i aktywne karnety.
        </p>
      </div>

      <div className="card-purchase-lookup__input">
        <div className="card-purchase-lookup__input__label">
          <input
            type="text"
            placeholder="Wpisz numer karty (bez kropek)"
            value={cardNumber}
            onChange={(e) => setCardNumber(e.target.value)}
            style={{
              flex: 1,
              padding: "10px 14px",
              borderRadius: "8px",
              border: "1px solid #dcdfe6",
              fontSize: "14px",
              fontWeight: "bold"
            }}
          />

          <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <input
              type="checkbox"
              checked={isConfirmed}
              onChange={(e) => setIsConfirmed(e.target.checked)}
            />
            Oświadczam, że jestem właścicielem karty/karnetu i że numer jest
            prawidłowy.
          </label>
        </div>

        <EAButton
          title={cooldown ? "Poczekaj..." : "Sprawdź"}
          onClick={handleCheck}
          disabled={isButtonDisabled}
        />



      </div>

      {localError && (
        <b className="alert alert-red">{localError}</b>
      )}

      {!cardDetails || !cardDetails.closeDate ? (
        <>
          {wasChecked && <b className="alert alert-red">
            Podany kod karty jest nieprawidłowy
          </b>}

        </>
      ) : (
        <div className="card-purchase-lookup__wrapper">
          <section className="ecard">
            <header className="ecard__header">
              <h2 className="ecard__title">Środki na koncie</h2>
            
            </header>






            {(Number(cardDetails?.captionBalanceII.replace(/<br\s*\/?>/gi, "").match(/[\d.]+$/)?.[0] || "0") > 0) ? ( 
            <div className="ecard__grid">
              <article className="ecard__tile is-positive">
                <div className="ecard__tile-label">
                  {cardDetails?.captionBalanceII.includes("<br/>")
                    ? cardDetails?.captionBalanceII.slice(
                      0,
                      cardDetails?.captionBalanceII.indexOf("<br/>")
                    )
                    : ""}
                </div>
                <div className="ecard__tile-amount">
                  {cardDetails?.captionBalanceII.includes("<br/>")
                    ? cardDetails?.captionBalanceII.slice(
                      cardDetails?.captionBalanceII.indexOf("<br/>") +
                      "<br/>".length
                    )
                    : ""}{" "}
                </div>
                {/* <p className="ecard__tile-desc">
                  {cardDetails?.descriptionBalanceII}{" "}
                </p> */}
                  <div className="ecard__close">
                Koniec ważności:{" "}
                <span className="ecard__close-date">
                  {cardDetails.closeDate
                    ? new Date(cardDetails.closeDate).toLocaleDateString(
                      "pl-PL"
                    )
                    : "—"}
                </span>
              </div>
              <div className="alert alert-red">
                    Środki po upływie terminu ważności przepadają.
              </div>
              </article>
            </div>) : (<b className="alert alert-yellow">Na tej karcie nie ma środków</b>)}
          </section>
          {cardDetails?.passes.map((item: Ticket, index: number) => (
            <div key={index}>
              <div className="ecard__belt">
                <div className="ecard__belt-name">{item.name || "—"}</div>

                <div className="ecard__belt-valid">
                  Ważność:{" "}
                  {item.validfrom
                    ? new Date(item.validfrom).toLocaleDateString("pl-PL")
                    : "—"}{" "}
                  -{" "}
                  {item.validto
                    ? new Date(item.validto).toLocaleDateString("pl-PL")
                    : "—"}
                </div>

                <div className="ecard__belt-counts">
                  <span>Wejść: {item.entrances}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CardPurchaseLookup;
